import React, { useContext } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Titled } from 'react-titled';
import {
  ErrorBoundary,
  ErrorContext,
  ErrorPage,
  FullPageLoadingSpinner,
  LoginPage,
} from 'csapps-react';
import { loginRequest } from './authConfig';
import Constants from './constants';
import AppMain from './components/AppMain';

export default function App() {
  const { instance, inProgress } = useMsal();
  const { state } = useContext(ErrorContext);
  const { errorMessage } = state;

  if (errorMessage) {
    return (
      <AppContainer>
        <div className="h-screen bg-ivory-oasis-10 p-4">
          <ErrorPage msg={errorMessage} />
        </div>
      </AppContainer>
    );
  }

  if (inProgress !== 'none') {
    return (
      <AppContainer>
        <FullPageLoadingSpinner />
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <UnauthenticatedTemplate>
        <LoginPage
          productName={Constants.productName}
          onLogin={() => instance.loginRedirect(loginRequest)}
        />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <AppMain />
      </AuthenticatedTemplate>
    </AppContainer>
  );
}

function AppContainer({ children }) {
  return (
    <Titled title={() => 'Worley - Digital platform'}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Titled>
  );
}
